import { FixedProductDetails } from '@vae/server/src/types/synerallApiTypes'
import dayjs from 'dayjs'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'
import React from 'react'
import { useTranslation } from 'react-i18next'
import useUser from '../../../contexts/hooks/useUser'

dayjs.extend(utc)
dayjs.extend(timezone)

type Props = { details: FixedProductDetails }

const LockInCard: React.FC<Props> = ({ details }) => {
	const { prices, validFrom, validTo } = details
	const { user } = useUser()

	const { t } = useTranslation('pages_contractInformation')

	const currentPrices = user?.language === 'en' ? prices.en : prices.fi
	const period = `${dayjs(validFrom).format('DD.MM.YYYY')}-${dayjs(validTo).subtract(1, 'minute').format('DD.MM.YYYY')}`

	return (
		<div className='lock-in'>
			<div className='info-container'>
				<div className='child'>
					<p className='header'>{t('price')}</p>
					<p className='text'>
						{currentPrices.hourlyPrice.toFixed(2).toString().replace('.', ',')} {t('priceUnit')}
					</p>
				</div>
				<div className='child'>
					<p className='header'>{t('perusmaksu')}</p>
					<p className='text'>
						{(currentPrices.monthlyPrice ?? 0).toFixed(2).toString().replace('.', ',')}{' '}
						{t('monthlyUnit')}
					</p>
				</div>
			</div>

			<div className='info-container'>
				<div className='child'>
					<p className='header'>{t('sopimustyyppi')}</p>
					<p className='text'>{t('priceLock')}</p>
				</div>

				<div className='child'>
					<p className='header'>{t('lockInPeriod')}</p>
					<p className='text'>{period}</p>
				</div>
			</div>
		</div>
	)
}

export default LockInCard
